/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */
const Color = require('../types/Color')
const kernel = require('../kernel/kernel')
const CListeObjets = require('./CListeObjets')
const CPrototype = require('./CPrototype')
const DataInputStream = require('../entreesSorties/DataInputStream')
const DataOutputStream = require('../entreesSorties/DataOutputStream')
module.exports = CMathGraphDoc

/**
 * Classe contenant des informations sur la figure et un array de CPrototype
 * (qui peut être vide) ainis que la CListeObjets contenant les objets proprement dits
 * graphiques et non graphiques.
 * Version réservée à mtgApp
 * @constructor
 * @param {String} idDoc : L'id du document ui est celui du svg contenant la figure.
 * @param {Boolean} displayOnLoad : true si la figure doit être affichée
 * dès que son chargement est terminé.
 * @param {Boolean} isActive : true si la figure est active et répond aux actions souris et clavier.
 * @param opacity : Nombre décimale définissant l'opacité des surfaces de la figure
 * @returns {CMathGraphDoc}
 */
function CMathGraphDoc (idDoc, displayOnLoad, isActive, opacity) {
  this.idDoc = idDoc;
  this.displayOnLoad = arguments.length>1 ? displayOnLoad : true; // Pas utilisé pour le moment
  this.isActive = arguments.length>2 ? isActive : true;
  this.numeroVersion = DataInputStream.numeroVersionActif;
  this.listePrincipale = new CListeObjets("radian",idDoc);
  this.listePrincipale.associeA(this);
  this.langage = kernel.userLan();
  this.texteFigure = "";
  this.tablePrototypes = [];
  this.isDirty = false;
  this.pointCapture = null;
  this.couleurFond = Color.white;
  this.imageFond = null;
  this.imageFondVisible = true;
  this.itemsCochesInterdits = true;
  this.listeIdMenus = [];
  this.opacity = arguments.length > 3 ? opacity : 0.2;
  this.type = ""; // Pour les événements souris
  // Des événements mousemove ne sont pas générés sur les périphériques uniquement tactiles
  // à la différece des événements mousedown
  this.hasMouse = false; // Sera mis à true si un mousemove event estr rencontré
}
/**
 * Fonction chargeant les éventuelles constructions de la figure (CPrototype)
 * @param {DataInputStream} inps
 * @param nVersion : Le n° de version de la liste dans laquelle on lit les prototypes
 * @returns {undefined}
 */
// Modifié version 5.2. On passe un paramètre nVersion qui représente le N° de version de la liste à partir de laquelle le prototype est chargé

CMathGraphDoc.prototype.readPrototypes = function(inps, nVersion){
  // On lit d'abord le nombre de prototypes
  var nbProt = inps.readInt();
  for (var i = 0; i < nbProt; i++) {
    var prot = new CPrototype(this.listePrincipale);
    prot.read(inps, nVersion);
    this.tablePrototypes.push(prot);
  }
};
/**
 * Fonction renvoyant la construction de la figure de nom nomProto
 * @param nomProto : String
 * @returns {*} null s'il n'y a pas de prototype de ce nom
 */
CMathGraphDoc.prototype.getPrototype = function(nomProto) {
  for (var i = 0; i < this.tablePrototypes.length; i++) {
    if(this.tablePrototypes[i].nom === nomProto) return this.tablePrototypes[i];
  }
  return null;
};
/**
 * Fonction enregistrant les pprototypes (constructions) de la figure.
 * @param {DataOutputStream} oups
 * @returns {undefined}
 */
CMathGraphDoc.prototype.writePrototypes = function(oups){
  oups.writeInt(this.tablePrototypes.length);
  for (var i = 0; i < this.tablePrototypes.length; i++) {
    var prot = this.tablePrototypes[i];
    prot.write(oups);
  }
};
/**
 * Fonction lisant le document depuis un flux de données binaires.
 * @param {DataInputStream} inps
 * @returns {undefined}
 */
CMathGraphDoc.prototype.read = function(inps) {
  // On saute les 17 premiers octets qui contiennent une chaine
  inps.skip(16);
  this.numeroVersion = inps.readInt();
  // Ligne suivante pour corriger un oubli dans la première version où le numéro de document
  // était nul
  if (this.numeroVersion === 0) this.numeroVersion = 5;
  if (this.numeroVersion > DataInputStream.numeroVersionActif) { // Amélioré version 4.4
    throw new Error("IOException");
  }
  if (this.numeroVersion >= 6) this.opacity = inps.readFloat();
  else this.opacity = 1; //pas de transparence pour les anciennes figures. A modifier dans Options Figure en cours
  this.langage = inps.readUTF(); // la langue dans laquelle a été créé le document
  // Changements pour la version 1.8 (version 3)
  // Changement pour version 2.0 : on enregistre le degré de transparence des surfaces pleines dans un float
  var couleurRouge, couleurVert, couleurBleu;
  couleurRouge = inps.readByte(); // initialement readUnsignedByte()
  couleurVert = inps.readByte();
  couleurBleu = inps.readByte();
  this.couleurFond = new Color(couleurRouge, couleurVert, couleurBleu);
  this.imageFondVisible = inps.readBoolean(); // Nouveau version 4.4
  this.modeTraceActive = inps.readBoolean(); // Nouveau version 4.4
  this.natImageFond = inps.readByte();
  if (this.natImageFond !== DataOutputStream.nat_noImage) {
    this.imageFond = inps.readBufferedImage();
    if (this.numeroVersion > 10) {
      this.widthImageFond = inps.readInt();
      this.heightImageFond = inps.readInt();
    }
    else {
      this.widthImageFond = svg.getAttribute("width");
      this.heightImageFond = svg.getAttribute("height");
    }
  }
  else this.imageFond = null;
  /* Supprimé version 5.3. Devenu inutile
  var svg = (this.idDoc !== null) ? document.getElementById(this.idDoc) : null;
  if (svg !== null) {
    // On créée un g destiné à contenir les traces d'objets
    this.gTraces = kernel.cens("g",{
      id : this.idDoc+"Traces"
    });
    svg.appendChild(this.gTraces);
    // this.indexOfFirstElement = svg.childNodes.length; Supprimé version mtgApp. Inutile
  }
  */
  // On lit un booléen indiquant si les codes d'items de menu correspondent à
  // des items interdits ou non
  this.itemsCochesInterdits = inps.readBoolean();
  // On charge l'éventuelle liste d'items de menus
  var nombreItems = inps.readInt();
  this.listeIdMenus = [];
  if (nombreItems !== 0) {
    for (var i = 0; i < nombreItems; i++) {
      var a = inps.readInt();
      this.listeIdMenus.push(a); // à revoir
    }
  }
  //motDePasseFigure = inps.readUTF();
  // this.motDePasseFigure = inps.readUTF(); Modifié version 5.0
  /* Modifié version 5.0
  this.protectionOptions = inps.readBoolean();
  this.protectionCopie = inps.readBoolean();
  this.protectionFigure = inps.readBoolean();
  this.protectionMenus = inps.readBoolean();
  this.protectionSecret = inps.readBoolean();
  */
  if (this.numeroVersion < 15) {
    inps.readUTF();
    inps.skip(5);
  }
  this.texteFigure = inps.readUTF();
  this.sizeWindowx = inps.readInt();
  this.sizeWindowy = inps.readInt();
  this.affichagesFiges = inps.readBoolean();
  this.marquesAnglesFigees = inps.readBoolean();
  // Nouveau pour la version 4.6 : Deux boolean disant si les champs d'édition peuvent avoir des boutons
  // Valeur et Fontions prédéfinies
  if (this.numeroVersion >= 10) {
    this.buttonValueAllowed = inps.readBoolean();
    this.buttonFunctionAllowed = inps.readBoolean();
  }
  this.readPrototypes(inps, this.numeroVersion);
  // Nouveauté pour la version 2.5 : La liste doit être au courant du n° de
  // version
  // de document
  this.listePrincipale.numeroVersion = this.numeroVersion;
  this.listePrincipale.associeA(this); // Modifié version 4.8
  this.listePrincipale.read(inps);
  this.listePrincipale.numeroVersion = DataInputStream.numeroVersionActif;
  this.numeroVersion = DataInputStream.numeroVersionActif;
};
/**
 * Fonction enregistrant le document dans un flux de données binaire.
 * @param {DataOutputStream} oups
 * @returns {undefined}
 */
CMathGraphDoc.prototype.write = function(oups){
  oups.writeCString("MathGraphJava1.0");
  oups.writeInt(this.numeroVersion);
  // Changement pour version 2.0 : on enregistre le degré de transparence des surfaces pleines dans un float
  oups.writeFloat(this.opacity);
  oups.writeUTF(this.langage);
  oups.writeByte(this.couleurFond.getRed());
  oups.writeByte(this.couleurFond.getGreen());
  oups.writeByte(this.couleurFond.getBlue());
  oups.writeBoolean(this.imageFondVisible);
  // Nouveau version 4.4 : un boolean disant si le mode trace est activé
  oups.writeBoolean(this.modeTraceActive);
  if (this.imageFond !== null) {
    oups.writeByte(this.natImageFond);
    oups.writeBufferedImage(this.imageFond, this.natImageFond); // Si pas d'image Fond un int de valeur nulle est enregistré dans le flux.
    oups.writeInt(this.widthImageFond);
    oups.writeInt(this.heightImageFond);
  }
  else oups.writeByte(DataOutputStream.nat_noImage);
  // On lit un booléen indiquant si les codes d'items de menu correspondent à
  // des items interdits ou non
  oups.writeBoolean(this.itemsCochesInterdits);
  // On enregistre l'éventuelle liste d'items de menus
  var nombreItems = this.listeIdMenus.length;
  oups.writeInt(nombreItems);
  if (nombreItems !== 0) {
    for (var i = 0; i < nombreItems; i++) {
      oups.writeInt(this.listeIdMenus[i]);
    }
  }
  oups.writeUTF(this.texteFigure);
  oups.writeInt(this.dimf.x);
  oups.writeInt(this.dimf.y);
  oups.writeBoolean(this.affichagesFiges);
  oups.writeBoolean(this.marquesAnglesFigees);
  oups.writeBoolean(this.buttonValueAllowed);
  oups.writeBoolean(this.buttonFunctionAllowed);
  this.writePrototypes(oups);
  this.listePrincipale.write(oups);
};

CMathGraphDoc.prototype.getBase64Code = function() {
  var oups = new DataOutputStream();
  this.write(oups);
  return kernel.base64Encode(oups.ba, false);
}

/**
 * Ajout version 5.0.
 * Renvoie un coefficient qui servira à agrandir les marques de segment, d'angles et les points
 * pour les écrans de haute résolution.
 * @return
 */
// Abandonné
// CMathGraphDoc.prototype.coefForPointsAndMarks = function() {
  // On considère une figure de taille 600x400 comme la norme et au-delà on applique un coefficient
  // proportionnel à l'aire de la figure
  /*
  var d = Math.sqrt(this.sizeWindowx*this.sizeWindowy/800000);
  if (d < 1) return 1; else if (d > 2.5) return 2.5; else return d;
  */
  // Pour la version js, toujours égal à 1
//  return 1;
// };

/**
 * Fonction changeant l'état du document
 * @param {boolean} val : true si le document a changé et false sinon
 */

CMathGraphDoc.prototype.setDirty = function(val) {
  this.isDirty = val;
};

/**
 * Fonction renvoyant true si l'outil d'inex index est autorisé par le document
 * @param index
 * @returns {boolean}
 */
CMathGraphDoc.prototype.toolDispo = function(index) {
  if (index === -1) return true;
  var b= false;
  for (var i = 0; i < this.listeIdMenus.length; i++) {
    b |= this.listeIdMenus[i] === index;
  }
  return this.itemsCochesInterdits ? !b : b;
};



// WEBPACK FOOTER //
// ./src/objets/CMathGraphDoc.js